
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/faq",
      function () {
        return require("private-next-pages/about-us/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/faq"])
      });
    }
  